import { PreparedSortCriteria } from '@steelbuy/api-integration';
import { ListingBuyerModelConverter, ListingBuyerModel, ApiModel } from '@steelbuy/ts-shared';
import cacheOptions from '../../utils/cacheOptions';
import { usePaginatedQuery } from '../../utils/usePaginatedQuery';

type BrowseListingOptions = {
    sort?: PreparedSortCriteria;
} & Record<string, unknown>;

export const BROWSE_LISTING_KEY = 'browse-listings';
const BROWSE_LISTING_PAGE_SIZE = 15;

const modelConverter = new ListingBuyerModelConverter();
const browseListingMapFn = (data: ListingBuyerModel) =>
    modelConverter.toViewModel(data as unknown as ApiModel<ListingBuyerModel>);

export const useBrowseListings = (options: BrowseListingOptions) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { sort, ...rest } = options;
    return usePaginatedQuery<ListingBuyerModel>({
        url: '/api/universal/search-listings',
        requestOptions: {
            pageSize: BROWSE_LISTING_PAGE_SIZE,
            filter: rest,
            sort,
        },
        mapFn: browseListingMapFn,
        queryKey: [BROWSE_LISTING_KEY, JSON.stringify(options)],
        keepPreviousData: true,
        queryOptions: {
            staleTime: cacheOptions['5_MINUTES'],
        },
        method: 'POST',
    });
};
